import React from 'react';

const Footer = () => {
  return (
    <footer className="app-footer">
      
    </footer>
  )
}

export default Footer;
